import type { FlightFilters } from '../types/flight.types';
import { flightFiltersToOrderingParam, normalizeFlightFilters } from '../types/flight.types';

export function buildFlightSearchParams(
  page: number,
  searchFilters?: FlightFilters
): Record<string, string | number> {
  const params: Record<string, string | number> = {};

  if (!searchFilters) {
    if (page > 1) {
      params.page = page;
    }
    return params;
  }

  const normalizedFilters = normalizeFlightFilters(searchFilters);
  params.ordering = flightFiltersToOrderingParam(normalizedFilters);

  if (searchFilters.stops.length > 0) {
    params.stops = searchFilters.stops.join(',');
  }

  if (searchFilters.airlines.length > 0) {
    params.airlines = searchFilters.airlines.join(',');
  }

  if (searchFilters.airports.length > 0) {
    params.airports = searchFilters.airports.join(',');
  }

  if (searchFilters.timeRange.startFrom) {
    params.departure_time_after = searchFilters.timeRange.startFrom;
  }

  if (searchFilters.timeRange.upTo) {
    params.departure_time_before = searchFilters.timeRange.upTo;
  }

  if (page > 1) {
    params.page = page;
  }

  return params;
}

export function serializeFlightSearchParams(params: Record<string, string | number>): string {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${String(value)}`)
    .join('&');
}

export function hasBackendFlightFiltersChanged(prev: FlightFilters, next: FlightFilters): boolean {
  return (
    prev.sortBy !== next.sortBy ||
    prev.sortOrder !== next.sortOrder ||
    prev.stops.join(',') !== next.stops.join(',') ||
    prev.airlines.join(',') !== next.airlines.join(',') ||
    prev.airports.join(',') !== next.airports.join(',') ||
    prev.timeRange.startFrom !== next.timeRange.startFrom ||
    prev.timeRange.upTo !== next.timeRange.upTo
  );
}
